import React from "react";
import Menu from "../../components/layout/Menu";

export default function DispatchesTable() {
  return <Menu category="Dépêche" label="Gestion des dépêches"></Menu>;
}
